.pageCell {    
    border-radius: 1rem;
    padding: 20px;
    height: 100%;
    width: 100%;
}

.white {
    background-color: var(--hps-white);
}

.transparentBlue {
    background-color: #05263743;
}